import { Outlet } from "react-router-dom";

const CatalogTypeRoot = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
};

export default CatalogTypeRoot;